
// src/routes/SigninStart.tsx
import { useEffect } from 'react';
import { getUserManager } from '../redux/store';
import { Spinny } from '../components/Spinny';
import { useSearchParams } from 'react-router-dom';
import Cookies from 'js-cookie';

export default function SigninStart() {
    const [params] = useSearchParams();
    const revTenantIdParam = params.get("revTenantId") || "";



    useEffect(() => {
        //this cookie is used in the sign in callback to determine which user manager instance to use for processing the callback and restoring the user.
        //either /common or /{tenantId} depending on whether this is a multi-tenant scenario or not.
        Cookies.set("revTenantId", revTenantIdParam, { secure: true, sameSite: 'None', expires: 365 });

        // Initiates the redirect to the authority; will return to /signin-callback
        console.log('Starting signinRedirect...', revTenantIdParam);

        getUserManager(revTenantIdParam).signinRedirect().catch((err) => {
            console.error('signinRedirect failed:', err);
        });
    }, [revTenantIdParam]);

    return <div><Spinny text={`Starting sign-in…`} />
    </div>;
}
